// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DqKn","rootNoMargin":"styles_rootNoMargin__30Oic"};